import React from "react";
import { RippleLoaderSVG } from "../../assets/svg";

const RippleLoader = () => {
  return (
    <>
      <div className="flex items-center justify-center w-full h-full ">
        <RippleLoaderSVG />
      </div>
    </>
  );
};

export default RippleLoader;